import React from "react";
import style from "./style.module.scss";
import cn from "classnames";

const OrdersContentColumn = ({
  children,
  gridColumnGap = 10,
  gridRowGap = 10,
  hide = false,
  position = false,
  className,
}) => {
  return (
    <div
      className={cn(
        style.column,
        className,
        { [style.hide]: hide },
        { [style.position]: position },
      )}
      style={{ gap: `${gridRowGap}px ${gridColumnGap}px` }}
    >
      {children}
    </div>
  );
};

export default OrdersContentColumn;
